import clsx from 'clsx';
import type { HTMLAttributes } from 'react';

import { Spotlight } from '../spolight';
import * as styles from './index.css';

interface QuickSearchInputProps extends HTMLAttributes<HTMLDivElement> {
  onClick?: () => void;
}

// Although it is called an input, it is actually a button.
export function QuickSearchInput({ onClick, ...props }: QuickSearchInputProps) {
  return (
    <div
      {...props}
      className={clsx([props.className, styles.root])}
      onClick={onClick}
      tabIndex={0}
    >
      <span className={styles.quickSearchBarEllipsisStyle}>New Search</span>
      <div className={styles.spacer} />
      <div className={styles.shortcutHint}>
        {environment.isMacOs ? '⌘ K' : 'Ctrl K'}
      </div>
      <Spotlight />
    </div>
  );
}
